import Icon from '../components/Icon.vue'

Icon.register({
  'mail-bulk': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M160 448c25.6 0 51.2-22.4 64-32 64-44.8 83.2-60.8 96-70.4v134.4c0 17.7-14.3 32-32 32h-256c-17.7 0-32-14.3-32-32v-134.4c12.8 9.6 32 25.6 96 70.4 12.8 9.6 38.4 32 64 32zM288 256c17.7 0 32 14.3 32 32v19.2c-25.6 19.2-22.4 19.2-115.2 86.4-9.6 3.2-28.8 22.4-44.8 22.4s-35.2-19.2-44.8-25.6c-92.8-67.2-89.6-67.2-115.2-86.4v-16c0-17.7 14.3-32 32-32h256zM544 160c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-192v-134.4l-0.3 0.2c-3.1-32.4-30.5-57.8-63.7-57.8h-96v-32c0-17.7 14.3-32 32-32h320zM512 288v-64h-64v64h64zM160 192v32h-96v-192c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v96h-224c-35.3 0-64 28.7-64 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mail-bulk.js
// module id = 1538
// module chunks = 0